module.exports = __webpack_public_path__ + "static/media/25.db9482e4.png";